// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__2lilZ","dataPoint":"Counter_dataPoint__3gHrH","value":"Counter_value__NMkfU","buttons":"Counter_buttons__2826c"};